"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityTagListCell = exports.EntityTagListCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_lang_1 = require("../../hooks/use-lang");
var to_array_1 = require("../../utils/to-array");
var sprintf_js_1 = require("sprintf-js");
var tag_list_1 = require("../elements/tag-list");
var tag_1 = require("../elements/tag");
var entity_multi_value_1 = require("./entity-multi-value");
var entity_value_1 = require("./entity-value");
exports.EntityTagListCellDefaultProps = {
  entity: [],
  itemLimit: 10
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EmptyLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme_1.theme.COLOR('text-subtle'))
});
var TagStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border-radius: 50px;\n  "], ["\n    border-radius: 50px;\n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-right: ", ";\n  "], ["\n    margin-bottom: ", ";\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(2))
});
var SingleValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  EmptyLabel: styled_components_1.default.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), EmptyLabelStyles),
  List: (0, styled_components_1.default)(tag_list_1.TagList)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  Value: (0, styled_components_1.default)(entity_multi_value_1.EntityMultiValue)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  SingleValue: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SingleValueStyles),
  Tag: (0, styled_components_1.default)(tag_1.Tag)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TagStyles)
};
var EntityTagListCell = function (props) {
  var className = props.className,
    entity = props.entity,
    itemLimit = props.itemLimit;
  var items = (0, to_array_1.toArray)(entity);
  var itemsToShow = !!itemLimit ? items.slice(0, itemLimit) : items;
  var extras = items.length - itemsToShow.length;
  var t = (0, use_lang_1.useLang)();
  return react_1.default.createElement(My.Container, {
    className: className
  }, !!items.length ? items.length > 1 ? react_1.default.createElement(My.List, null, itemsToShow.map(function (item) {
    return react_1.default.createElement(My.Value, {
      key: item.id,
      entity: item
    });
  }), !!extras && react_1.default.createElement(My.Tag, {
    isListItem: true,
    isExtra: true
  }, (0, sprintf_js_1.sprintf)(t("+ %d more"), extras))) : react_1.default.createElement(My.SingleValue, {
    entity: items[0]
  }) : react_1.default.createElement(My.EmptyLabel, null, t('( none )')));
};
exports.EntityTagListCell = EntityTagListCell;
exports.EntityTagListCell.defaultProps = exports.EntityTagListCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;